export enum SourceType {
  LIFEN_INTEGRATION_FORWARD = 'lifen_integration_forward',
  LIFEN_DOCUMENT_FORWARD = 'lifen_document_forward',
  FORWARD = 'forward',
  UNKNOWN = 'unknown',
  MSS_EMAIL = 'mss_email',
  HL7_MDM_CDA = 'hl7_mdm_cda',
  HL7_ORU_CDA = 'hl7_oru_cda',
  HL7_ORU_PDF = 'hl7_oru_pdf',
  IV = 'iv',
  IN_PDF = 'in_pdf',
  API = 'api',
}

export interface DocumentSource {
  type: SourceType;
  display?: string;
}
